import { API_BASE_URL } from '@/config/api';
import { createClientKeyFetch } from '@/utils/clientKeyFetch';

// Set in this app's .env (and in the build environment for store builds): see .env.example. Expo only bakes in
// EXPO_PUBLIC_* values when they are read exactly like this.
const CLIENT_ID = process.env.EXPO_PUBLIC_CLIENT_ID?.trim() ?? '';
const CLIENT_KEY = process.env.EXPO_PUBLIC_CLIENT_KEY?.trim() ?? '';

/** The two headers, for the few requests that do not go through fetch (native file uploads). Empty when no key is set. */
export function clientKeyHeaders(): Record<string, string> {
  return CLIENT_ID && CLIENT_KEY ? { 'x-client-id': CLIENT_ID, 'x-client-key': CLIENT_KEY } : {};
}

/** Makes every request to the API carry this app's client id and key. Does nothing when no key is configured. */
export function installClientKey(): void {
  if (!CLIENT_ID || !CLIENT_KEY || !API_BASE_URL) return;
  const scope = globalThis as unknown as { fetch: typeof fetch; __clientKeyInstalled?: boolean };
  if (scope.__clientKeyInstalled) return;
  scope.__clientKeyInstalled = true;
  scope.fetch = createClientKeyFetch(scope.fetch.bind(scope), API_BASE_URL, CLIENT_ID, CLIENT_KEY);
}
